import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        // DeepSky brand palette
        primary: '#6ea8ff',   // light blue accent (buttons, active)
        secondary: '#1b2c4d', // navy (panels, secondary buttons)
        accent: '#b98bff',    // violet accent
        info: '#6ea8ff',
        background: '#070b16'
      }
    }
  }
})
